import apiClient from './client'
import publicApiClient from './publicClient'

export const legalService = {
  // Lecture (admin, pour édition)
  get:    (slug) => apiClient.get(`/legal/${slug}`),
  // Écriture (staff)
  update: (slug, data) => apiClient.put(`/legal/${slug}`, data),
  // Lecture publique (page front)
  getPublic: (slug) => publicApiClient.get(`/legal/${slug}`),
}

export default legalService
